<template>
	<div class="surebg" v-loading="loading" :element-loading-text="$t('bc.bc_51')"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
		<div class="reservetop">
			<p>{{$t('ReserveCar.ReserveCar_1')}}</p>
			<span>{{$t('OrderInfoDetail.OrderInfoDetail_2')}}</span>
		</div>
		<div class="reservebg">
			<el-form ref="form" :model="form">
				<el-form-item :label="$t('ReserveCar.ReserveCar_3')">
					<div class="reservelab row">
						<el-image style="" :src="url" fit="contain"></el-image>
						<span>{{carname}}</span>
					</div>
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_4')">
					{{form.timedata}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_5')">
					{{form.value1}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_6')">
					{{form.type}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_7')" v-if="form.checked">
					追加する（¥{{form.daymoneyformat}}）
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_7')" v-else>
					-
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_8')">
					{{form.region}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_9')" v-if="form.pernum">
					{{form.pernum}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_9')" v-else>
					{{$t('Reservesure.Reservesure_3')}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_10')">
					{{form.name}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_11')">
					{{form.secondname}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_12')">
					{{form.tel}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_13')">
					{{form.email}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_14')">
					{{form.suremail}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_15')">
					{{form.contraytext}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_67')"  >
					<span>{{photo}}</span>
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_16')">
					{{form.resourcetext}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_17')">
					{{form.bx}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_18')" v-if="form.way==1">
					{{$t('ReserveCar.ReserveCar_26')}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_18')" v-if="form.way==2">
					{{$t('ReserveCar.ReserveCar_25')}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_18')" v-if="form.way==3">
					{{$t('ReserveCar.ReserveCar_36')}}
				</el-form-item>
				
				
				<el-form-item :label="$t('ReserveCar.ReserveCar_19')" v-if="form.zysx=='1'">
					{{$t('ReserveCar.ReserveCar_34')}}
				</el-form-item>
				<el-form-item :label="$t('ReserveCar.ReserveCar_19')" v-else>
					{{$t('ReserveCar.ReserveCar_38')}}
				</el-form-item>
				
				<el-form-item :label="$t('Reservesure.Reservesure_1')">
					<div class="redtext">¥{{form.allmonech}}</div>
				</el-form-item>
			</el-form>
			<div class="carlinbn row f-b" @click="Add_TKA()">
				
				<div class="carlinbntext">
					{{$t('Reservesure.Reservesure_2')}}
				</div>
				
				<div>
					<img src="@/assets/default/calendatJT.png" alt="">
				</div>
				
			</div>
			<div class="reservebtn" @click="ReserveCar()">{{$t('Reservesure.Reservesure_4')}}</div>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'Reservesure',
		inject: ['reload'],
		components: {

		},
		data() {
			return {
				loading: false,
				form: {
					tid: '',
					curTime: '',
					timedata: '',
					titleTime: '',
					value1: '',
					type: '',
					typeid: '',
					typemoney: '',
					typetime: '',
					checked: false,
					region: '',
					pernum: '',
					name: '',
					secondname: '',
					tel: '',
					email: '',
					suremail: '',
					contray: '',
					contraytext: '',
					resource: '',
					bx: '',
					bxid: '',
					bxmoney: '',
					way: '',
					fh: '',
					way1: '',
					waymonth: '',
					wayyear: '',
					wayname: '',
					wayx: '',
					wayemail: '',
					waytel: '',
					twofh: '',
					twoway1: '',
					twowaymonth: '',
					twowayyear: '',
					twowayname: '',
					twowayx: '',
					twowayemail: '',
					twowaytel: '',
					sendfh: '',
					sendway1: '',
					sendwaymonth: '',
					sendwayyear: '',
					sendwayname: '',
					sendwayx: '',
					sendwayemail: '',
					sendwaytel: '',
					photo1: '',
					photo2: '',
					photo3: '',
					zysx: false,
					allmoney: 0,
					allmonech: 0,
					endtime: '',
					hourlist: [],
					minslist: [],
					ckadddaylist: [],
					daymoneyformat: 0,

				},
				carname: '',
				photo: '',
				carid: '',
				daymoney: '',
				difference: '',
				addnum: '',
				linecarid: '',
				three: '',
				six: '',
				nine: '',
				ersi: '',
				personnum: '',
				addday: '',
				ckaddday : '',
				ckadddaytext : '',
				sendway: '',
				stime:'',
				url: '',
				lang: 0
			};
		},
		watch: {},
		computed: {},
		
		methods: {
			fillZero(val) {
				let newVAL = '';
				if (val.toString().length < 2) {
					newVAL = "0" + val.toString();
				} else {
					newVAL = val.toString();
				}
				return newVAL;
			},
			Add_TKA() {

				var stime  = Math.floor (Math.random() * 100000 );
				if (this.$i18n.locale == 'ja') {
					this.lang = 0
				}
				else if (this.$i18n.locale == 'zh') {
					this.lang = 1
				}
				else if (this.$i18n.locale == 'en') {
					this.lang = 2
				}
				this.loading = true
				let zysxstatus = ''
				if (this.form.zysx == true) {
					zysxstatus = 1
				} else {
					zysxstatus = 0
				}
				var curTime = this.form.curTime + ' ' + this.form.value1
				curTime = new Date(curTime); //指定的日期
				let zzmoney = ''


				var addtime = this.form.typetime.replace('h', '');
				console.log(addtime)
				//curTime.setMinutes(curTime.getMinutes() + 30 ); //洗车间隔从1小时变成30分钟
				//var addHour  = curTime.setHours(curTime.getHours() + Number(addtime) ); //先加上套餐得日期
				var addHour = curTime.setHours(curTime.getHours() + Number(addtime) + 1); //先加上套餐得日期


				if (this.form.checked.toString() == 'true') //选择了加一日
				{
					addHour = new Date(addHour).setHours(new Date(addHour).getHours() + 24);
					zzmoney = this.daymoney * this.ckaddday.split(" ")[0];
				} else {
					zzmoney = 0;
				}


				console.log(new Date(addHour).getFullYear()) //年  //获取加完后的年

				console.log(this.fillZero(new Date(addHour).getMonth() + 1)) // 获取加完后的月
				console.log(this.fillZero(new Date(addHour).getDate())) // 获取加完后的日
				console.log(this.fillZero(new Date(addHour).getHours())) // 获取加完后的时
				console.log(this.fillZero(new Date(addHour).getMinutes())) // 获取加完后的分
				this.form.endtime = new Date(addHour).getFullYear() + '-' + this.fillZero(new Date(addHour).getMonth() +
					1) + '-' + this.fillZero(new Date(addHour).getDate()) + ' ' + this.fillZero(new Date(addHour)
					.getHours()) + ':' + this.fillZero(new Date(addHour).getMinutes())

				if (this.form.way == 3) {
					this.sendway = 2;
					this.form.sendfh = this.form.fh
					this.form.sendway1 = this.form.way1
					this.form.sendwaymonth = this.form.waymonth
					this.form.sendwayyear = this.form.wayyear
					this.form.sendwayx = this.form.wayx
					this.form.sendwayname = this.form.wayname
					this.form.sendwayemail = this.form.wayemail
					this.form.sendwaytel = this.form.waytel

				}
				if (this.form.way == 2) {
					this.sendway = 2;
					this.form.sendfh = this.form.twofh
					this.form.sendway1 = this.form.twoway1
					this.form.sendwaymonth = this.form.twowaymonth
					this.form.sendwayyear = this.form.twowayyear
					this.form.sendwayx = this.form.twowayx
					this.form.sendwayname = this.form.twowayname
					this.form.sendwayemail = this.form.twowayemail
					this.form.sendwaytel = this.form.twowaytel
				}

				if (this.form.way == 1) {
					this.sendway = 1;
					this.form.sendfh = ""
					this.form.sendway1 = ""
					this.form.sendwaymonth = ""
					this.form.sendwayyear = ""
					this.form.sendwayx = ""
					this.form.sendwayname = ""
					this.form.sendwayemail = ""
					this.form.sendwaytel = ""
				}

                let id = Date.now()
                sessionStorage.setItem('ID', id);
				console.log('ID:', id);
				console.log('ID:', sessionStorage.getItem('ID'));

				this.$api.post(this.$config.Add_TKA, {
						'sMDHID': this.carid,
						'sMDHNM': this.carname,
						'sHOURS': this.form.typeid,
						'sHOURC': this.form.typemoney,
						'sMSTDT': this.form.curTime,
						'sSTAHO': this.form.curTime + ' ' + this.form.value1,
						'sADDAY': zzmoney,
						'sENDHO': this.form.endtime,
						'sPBAID': sessionStorage.getItem('log_mstid') == null ? '' : sessionStorage.getItem(
							'log_mstid'),
						'sFAMNM': this.form.name,
						'sGIVNM': this.form.secondname,
						'sTELNO': this.form.tel,
						'sEMAIL': this.form.email,
						'sCOYID': this.form.contray,
						'sDRIVE': this.form.resource,
						'sPAYID': ('0' + this.sendway),
						'sADUCT': this.form.region,
						'sKIDCT': this.form.pernum,
						'sDFPRC': this.form.allmoney,
						'sCOMNT': zysxstatus,
						'sINNAM': this.form.bxid,
						'sINSRE': this.form.bxmoney,
						'sCADID': this.form.sendfh,
						'sCACVV': this.form.sendway1,
						'sCAMON': this.form.sendwaymonth,
						'sCAYER': this.form.sendwayyear,
						'sCANAM': this.form.sendwayx,
						'sCAAME': this.form.sendwayname,
						'sCAEML': this.form.sendwayemail,
						'sCATEL': this.form.sendwaytel,
						'sADDNUM': this.addnum,
						'sLANG':this.lang,
						'stime': stime,
						'sID':id,
						'photo1':this.form.photo1,
						'photo2':this.form.photo2,
						'photo3':this.form.photo3
					},
					// 请求成功
					success => {
						//this.loading = false
						if (success.KKSTR == 'Y') {							
							//this.univapay()	
							const amount = this.form.allmonech.replace(/,/g, '');
							////王哥测试店铺
							//this.url1 = `https://checkout.univapay.com/forms/ccafd516-6c78-4cb7-9c32-04dfdcea7277?appId=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcHBfdG9rZW4iLCJpYXQiOjE3MTY4ODQ3NjMsIm1lcmNoYW50X2lkIjoiMTFlYzhmMGEtNDRiMy00NGQyLTllZjItOTdjMWE2MGNjMDVjIiwic3RvcmVfaWQiOiIxMWVjOGYwYS1hYTg2LWVhZDQtOWRkZS1kM2MxYjc3ODgyMDgiLCJkb21haW5zIjpbXSwibW9kZSI6InRlc3QiLCJjcmVhdG9yX2lkIjoiMTFlYzhmMGEtNDRiMy00NGQyLTllZjItOTdjMWE2MGNjMDVjIiwidmVyc2lvbiI6MSwianRpIjoiMTFlZjFjY2ItZWJlMi1jMjU1LWIzMmUtYWRlZjgwNDk3MTU4In0.5408xHB5j4CD_b5VObO8DCPGGM5UaWTmgbQTEicMAII&cvvAuthorize=true&type=recurring&amount=${amount}&customer_id=${stime}`;
							//租车真实店铺
							this.url1 = `https://checkout.univapay.com/forms/59eb54a3-33fc-4fde-821a-afbf7d748a9e?appId=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcHBfdG9rZW4iLCJpYXQiOjE2Njk2OTUzMDIsIm1lcmNoYW50X2lkIjoiMTFlZDM4OTQtMGY0ZC1kNzU2LTg0MDctMWI2YjJjZDUyYWUzIiwic3RvcmVfaWQiOiIxMWVkMzg5NC02MmM0LTE5NGEtODQzNC1hNzMzMzRjZmY4NGEiLCJkb21haW5zIjpbXSwibW9kZSI6ImxpdmUiLCJjcmVhdG9yX2lkIjoiMTFlZDM4OTQtMGY0ZC1kNzU2LTg0MDctMWI2YjJjZDUyYWUzIiwidmVyc2lvbiI6MSwianRpIjoiMTFlZDZmOWMtNjU5MC1jMGQ0LTlhZWEtMjliZmM1ODljOGVlIn0.aZTpaGBqr_WB0-C_Fr0rbO8hYHbhY7gZKOGnCaig8J0&cvvAuthorize=true&type=recurring&amount=${amount}&customer_id=${stime}`;
							//租车测试店铺
							//this.url1 = `https://checkout.univapay.com/forms/11efd7c1-492f-bede-bfc6-2720a56d1731?appId=eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJhcHBfdG9rZW4iLCJpYXQiOjE3Mzc0NDEwNjEsIm1lcmNoYW50X2lkIjoiMTFlZDM4OTQtMGY0ZC1kNzU2LTg0MDctMWI2YjJjZDUyYWUzIiwic3RvcmVfaWQiOiIxMWVkMzg5NC02MmM0LTE5NGEtODQzNC1hNzMzMzRjZmY4NGEiLCJkb21haW5zIjpbXSwibW9kZSI6InRlc3QiLCJjcmVhdG9yX2lkIjoiMTFlZDM4OTQtMGY0ZC1kNzU2LTg0MDctMWI2YjJjZDUyYWUzIiwidmVyc2lvbiI6MSwianRpIjoiMTFlZmQ3YzEtNDg0Yy0zYWVjLWFmMmQtNWZjZGRiYzZkN2FkIn0.2QYM6YpymGKOuANGKtKAephyBeZk6E8ImgImENth3pw&cvvAuthorize=true&type=recurring&amount=${amount}&customer_id=${stime}`;
							
							window.open(this.url1, '_self');
						} else if (success.KKSTR == 'O') {
							this.loading = false
							this.$message({
								message: this.$t('bc.bc_55'), //有人抢先下单了
								type: 'error'
							});
				
						} else {
							this.loading = false
							this.$message({
								message: this.$t('bc.bc_41'), //预约失败
								type: 'error'
							});
						}
					},
					// 请求失败
					error => {
						this.loading = false
						this.$message({
							message: this.$t('bc.bc_20'),
							type: 'error'
						});
					}
				)
				
			},
			
			ReserveCar() {
				this.$router.push({
					name: 'ReserveCar',
					query: {
						linecarid: this.linecarid,
						curTime: this.form.curTime,

					} // 要传递的参数
				})


				let form = {
					url: this.url,
					carname: this.carname,
					carid: this.carid,
					daymoney: this.daymoney,
					difference: this.difference,
					addnum: this.addnum,
					three: this.three,
					six: this.six,
					nine: this.nine,
					ersi: this.ersi,
					personnum: this.personnum,
					addday: this.addday,
					ckaddday: this.form.ckaddday,
					ckadddaytext : this.form.ckadddaytext,
					tid: this.tid,
					timedata: this.form.timedata,
					titleTime: this.form.titleTime,
					value1: this.form.value1,
					hours: this.form.hours,
					mins: this.form.mins,
					type: this.form.type,
					typeid: this.form.typeid,
					typemoney: this.form.typemoney,
					typetime: this.form.typetime,
					checked: this.form.checked,
					region: this.form.region,
					pernum: this.form.pernum,
					name: this.form.name,
					secondname: this.form.secondname,
					tel: this.form.tel,
					email: this.form.email,
					suremail: this.form.suremail,
					contray: this.form.contray,
					contraytext: this.form.contraytext,
					resource: this.form.resource,
					resourcetext: this.form.resourcetext,
					bx: this.form.bx,
					bxid: this.form.bxid,
					bxmoney: this.form.bxmoney,
					way: this.form.way,
					fh: this.form.fh,
					way1: this.form.way1,
					waymonth: this.form.waymonth,
					wayyear: this.form.wayyear,
					wayname: this.form.wayname,
					wayx: this.form.wayx,
					wayemail: this.form.wayemail,
					waytel: this.form.waytel,
					twofh: this.form.twofh,
					twoway1: this.form.twoway1,
					twowaymonth: this.form.twowaymonth,
					twowayyear: this.form.twowayyear,
					twowayname: this.form.twowayname,
					twowayx: this.form.twowayx,
					twowayemail: this.form.twowayemail,
					twowaytel: this.form.twowaytel,
					zysx: this.form.zysx,
					hourlist: this.form.hourlist,
					minslist: this.form.minslist,
					ckadddaylist : this.form.ckadddaylist,
					photo1:  this.form.photo1,
					photo2:  this.form.photo2,
					photo3:  this.form.photo3

				}

				sessionStorage.setItem("orderForm", JSON.stringify(form));
			},
		},
		created() {
			console.log(this.$route.params)

			let form = JSON.parse(sessionStorage.getItem("orderForm"));

			this.tid = form.tid
			this.url = form.url
			this.carname = form.carname
			this.carid = this.$route.query.carid
			this.linecarid = form.linecarid
			this.daymoney = form.daymoney
			this.difference = form.difference
			this.addnum= form.addnum
			this.ckaddday = form.ckaddday
			if(this.ckaddday.split(" ")[0]>0 && this.form.typeid != '3'){
			this.form.daymoneyformat = (Number(this.difference)+Number(form.daymoney)* Number(this.ckaddday.split(" ")[0])).toLocaleString();
			}else{
			this.form.daymoneyformat = (Number(form.daymoney)* Number(this.ckaddday.split(" ")[0])).toLocaleString();
			}
			this.form.timedata = form.timedata
			this.form.curTime = form.curTime
			this.form.titleTime = form.titleTime
			this.form.value1 = form.value1

			this.form.hours = form.hours
			this.form.mins = form.mins
			this.form.type = form.type
			this.form.typeid = form.typeid
			this.form.typemoney = form.typemoney
			this.form.typetime = form.typetime
			this.form.checked = form.checked
			this.form.ckaddday = form.ckaddday
			this.form.ckadddaytext = form.ckadddaytext
			this.form.region = form.region
			this.form.pernum = form.pernum
			this.form.name = form.name
			this.form.secondname = form.secondname
			this.form.tel = form.tel
			this.form.email = form.email
			this.form.suremail = form.suremail
			this.form.contray = form.contray
			this.form.contraytext = form.contraytext
			this.form.resource = form.resource
			this.form.resourcetext = form.resourcetext
			this.form.bx = form.bx
			this.form.bxid = form.bxid
			
			
			this.form.bxmoney = form.bxmoney
			
			if(this.form.checked == true)
			{
				this.form.bxmoney=form.bxmoney* (Number(this.ckaddday.split(" ")[0]) + 1)
			}
			
			this.form.way = form.way
			this.form.fh = form.fh

			this.form.way1 = form.way1
			this.form.waymonth = form.waymonth
			this.form.wayyear = form.wayyear
			this.form.wayname = form.wayname
			this.form.wayx = form.wayx
			this.form.wayemail = form.wayemail
			this.form.waytel = form.waytel

			this.form.twofh = form.twofh
			this.form.twoway1 = form.twoway1
			this.form.twowaymonth = form.twowaymonth
			this.form.twowayyear = form.twowayyear
			this.form.twowayname = form.twowayname
			this.form.twowayx = form.twowayx
			this.form.twowayemail = form.twowayemail
			this.form.twowaytel = form.twowaytel
			this.form.zysx = form.zysx

			this.form.hourlist = form.hourlist
			this.form.minslist = form.minslist
			this.form.ckadddaylist = form.ckadddaylist
			this.form.photo1 = form.photo1
			this.form.photo2 = form.photo2
			this.form.photo3 = form.photo3
			if (this.form.photo1 == true && this.form.photo2 == false && this.form.photo3 == false) {
				this.photo=	this.$t('ReserveCar.ReserveCar_68')
			}else if(this.form.photo1 == false &&this.form.photo2 == true && this.form.photo3 == false){
				this.photo=	this.$t('ReserveCar.ReserveCar_69')
			}else if(this.form.photo1 == false &&this.form.photo2 == false && this.form.photo3 == true){
				this.photo=	this.$t('ReserveCar.ReserveCar_73')
			}else if(this.form.photo1 == true &&this.form.photo2 == true && this.form.photo3 == false){
				this.photo=this.$t('ReserveCar.ReserveCar_68') + " / "	+ this.$t('ReserveCar.ReserveCar_69') 
			}else if (this.form.photo1 == true && this.form.photo2 == false && this.form.photo3 == true) {
				this.photo=	this.$t('ReserveCar.ReserveCar_68') +" / " + this.$t('ReserveCar.ReserveCar_73') 
			}else if(this.form.photo1 == false &&this.form.photo2 == true && this.form.photo3 == true){
				this.photo=	this.$t('ReserveCar.ReserveCar_69') +" / " + this.$t('ReserveCar.ReserveCar_73') 
			}else if(this.form.photo1 == true &&this.form.photo2 == true && this.form.photo3 == true){
				this.photo=this.$t('ReserveCar.ReserveCar_68') + " / "	+ this.$t('ReserveCar.ReserveCar_69') + " / "	+ this.$t('ReserveCar.ReserveCar_73') 
			}else {
				this.photo="--"
			}

			this.three = form.three
			this.six = form.six
			this.nine = form.nine
			this.ersi = form.ersi
			this.personnum = form.personnum
			this.addday = form.addday
			if (this.form.checked == true) {
				if( Number(this.ckaddday.split(" ")[0])>1){
				this.form.allmoney = Number(this.form.typemoney) + Number(this.form.bxmoney) +  Number(this.difference) + (Number(this.daymoney)* Number(this.ckaddday.split(" ")[0]))
				}else{
				this.form.allmoney = Number(this.form.typemoney) + Number(this.form.bxmoney)+ (Number(this.daymoney)* Number(this.ckaddday.split(" ")[0]))	
				}
			} else {
				this.form.allmoney = Number(this.form.typemoney) + Number(this.form.bxmoney)
			}
			this.form.allmonech = (this.form.allmoney || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
			this.form.value1 = form.value1;

		},
		mounted() {}
	}
</script>


<style scoped>
	@media only screen and (min-width:680px) {
		.surebg {
			width: 80%;
			margin: 0 auto;
		}

		.reservebg {
			width: 80%;
			margin: 0 auto;
			margin-top: 30px
		}

		.reservetop>p {
			font-size: 50px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 70px
		}

		.carlinbn {
			margin: 60px auto;
			width: 40%;
			height: 60px;
			background: #FF9C00;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.carlinbntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 24px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff
		}

		.reservebtn {
			width: 22%;
			margin: 30px auto;
			text-align: center;
			background-color: #666666;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff;
			height: 35px;
			line-height: 35px;
			margin-bottom: 80px;
			cursor: pointer;
		}
		/deep/.el-image {
			width: 160px;
			height: 96px
		}
	.reservelab>span {
		line-height: 40px;
		margin-left: 12px;
		font-size: 16px;
		font-family: Roboto-Bold, Roboto;
		display: block;
		width: calc(100% - 180px);
	}
	}

	@media only screen and (max-width:680px) {
		.surebg {
			width: 92%;
			margin: 0 auto;
		}

		.reservebg {
			width: 100%;
			margin: 0 auto;
			margin-top: 30px
		}

		.reservetop>p {
			font-size: 30px;
			font-family: Roboto-Bold, Roboto;
			margin-top: 30px
		}

		.carlinbn {
			margin: 60px auto;
			width: 60%;
			height: 60px;
			background: #FF9C00;
			line-height: 60px;
			padding: 0 10px;
			box-sizing: border-box;
			cursor: pointer;
		}

		.carlinbntext {
			width: calc(100% - 16px);
			text-align: center;
			font-size: 18px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff
		}

		.reservebtn {
			width: 32%;
			margin: 30px auto;
			text-align: center;
			background-color: #666666;
			font-size: 14px;
			font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
			color: #fff;
			height: 35px;
			line-height: 35px;
			margin-bottom: 80px;
			cursor: pointer;
		}
		/deep/.el-image {
			width: 140px;
			height: 86px
		}
	.reservelab>span {
		line-height: 40px;
		margin-left: 10px;
		font-size: 15px;
		font-family: Roboto-Bold, Roboto;
		display: block;
		width: calc(100% - 150px);
	}
	}


	.reservetop>span {
		font-size: 12px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
	}

	.reservelab {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	}


	.row {
		display: flex;
		flex-direction: row;
	}

	/deep/ .my-label {
		text-algin: center !important;
		width: 28%
	}

	.el-form {
		border: 1px solid #ddd;
		background-color: #FAFAFA;
	}

	.el-form-item {
		border-bottom: 1px solid #ddd;
		margin: 0;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	/deep/ .el-form-item__label {
		/* border-right: 1px solid #ddd; */
		display: flex;
		align-items: center;
		text-align: center;
		justify-content: center;
		height: 100%;
		background-color: #FAFAFA;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Bold, Noto Sans CJK JP;
		font-weight: bold;
		color: #000;
		height: 60px;
		width: 28%;
		line-height: 1.2;
	}

	/deep/ .el-radio-button__inner,
	.el-radio-group {
		line-height: 60px;
	}

	/deep/ .el-form-item__content {
		display: flex;
		align-items: center;
		padding: 10px 16px;
		line-height: 40px;
		font-size: 14px;
		font-family: Noto Sans CJK JP-Medium, Noto Sans CJK JP;
		width: 72%;
		background-color: #fff;
		border-left: 1px solid #ddd;
		min-height: 60px;
	}



	.carlinbn img {
		width: 14px;
		height: 14px;
		display: block;
		margin-top: 23px;
	}

	.redtext {
		font-size: 24px;
		font-family: Roboto-Medium, Roboto;
		color: #E20000;
	}

	/* /deep/ .el-form-item:nth-child(1) .el-form-item__label {
		height: 136px;
	} */

	/deep/ .el-form-item:nth-child(1) .el-form-item__content {
		padding: 20px 16px;
	}

	/* /deep/ .el-form-item:nth-child(14) .el-form-item__label {
		height: 180px;
	} */
</style>
